import {Component, computed, input} from '@angular/core';
import {IconsComponent} from '../icons/icons.component';

@Component({
  selector: 'app-spinner',
  imports: [
    IconsComponent
  ],
  templateUrl: './spinner.html',
  styleUrl: './spinner.css'
})
export class Spinner {
  size = input<'sm' | 'md' | 'lg' | 'xl'>('md');

  sizeClasses = computed(() => {
    return {
      'sm': 'w-4 h-4',
      'md': 'w-6 h-6',
      'lg': 'w-8 h-8',
      'xl': 'w-10 h-10',
    }[this.size()];
  });
}
